<div id="layout-wrapper">
  <app-horizontaltopbar></app-horizontaltopbar>
  <app-horizontalnavbar></app-horizontalnavbar>
  <!-- ============================================================== -->
  <!-- Start right Content here -->
  <!-- ============================================================== -->
  <div class="main-content">
    <div class="page-content-mobile">
      <router-outlet></router-outlet>
    </div>
    <!-- <app-footer-mobile></app-footer-mobile> -->

  </div>

  <app-rightsidebar></app-rightsidebar>
</div>
<!-- END layout-wrapper -->
